import React, { useState } from 'react';
import Alerts from './Alerts';
import Notification from './Notification';

const tabButtonStyle = (isActive: boolean): React.CSSProperties => ({
    background: 'transparent',
    color: '#ffffff',
    border: 'none',
    padding: '16px 12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    borderBottom: isActive ? '2px solid #FA6020' : '3px solid transparent',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    marginBottom: '-2px',
});

const AlertsNotification: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'alerts' | 'notification'>('alerts');

    const handleTabChange = (tab: 'alerts' | 'notification') => {
        setActiveTab(tab);
    };

    return (
        <div className="alerts-notification-container">
            <div className="alerts-notification-header" style={{ 
                background: '#1e2a3a', 
                borderBottom: '2px solid #2d3748', 
                padding: '0 24px' 
            }}>
                <div className="tab-navigation" style={{ display: 'flex', gap: '2px' }}>
                    <button 
                        className={`tab-btn ${activeTab === 'alerts' ? 'active' : ''}`}
                        onClick={() => handleTabChange('alerts')}
                        style={tabButtonStyle(activeTab === 'alerts')}
                    >
                        Alerts
                    </button>
                    <button 
                        className={`tab-btn ${activeTab === 'notification' ? 'active' : ''}`}
                        onClick={() => handleTabChange('notification')}
                        style={tabButtonStyle(activeTab === 'notification')}
                    >
                        Notification History
                    </button>
                </div>
            </div>
            
            <div className="tab-content">
                {activeTab === 'alerts' ? <Alerts /> : <Notification />}
            </div>
        </div>
    );
};

export default AlertsNotification;
